import { useLanguage } from "../../i18n/LanguageContext";
import { Reveal } from "./Reveal";
import { SectionHeader } from "./SectionHeader";
import { WorldNetwork } from "./WorldNetwork";

const CHIPS = ["Global Payments", "Cross-Border Transfers", "Rewards & Bonuses", "Community Growth"];

export const GlobalNetwork = () => {
    const { t } = useLanguage();
    return (
        <section data-testid="global-network-section" className="relative overflow-hidden border-t border-white/5 bg-nx-base py-20 sm:py-24 lg:py-32">
            <div className="mx-auto max-w-7xl px-5 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-12">
                    <div className="lg:col-span-5">
                        <SectionHeader
                            label={t("Global Network")}
                            testId="global-network"
                            title={<>{t("Connecting the World")}<br />{t("with Blockchain Technology.")}</>}
                            description={t("One world, one system. Nexora Global is built to be borderless — value flows freely, securely and transparently across the global ecosystem.")}
                        />
                        <Reveal delay={0.2} className="mt-9 flex flex-wrap gap-2.5">
                            {CHIPS.map((chip) => (
                                <span key={chip} className="rounded-full border border-white/10 bg-nx-elev px-4 py-2 text-[11px] font-bold uppercase tracking-[0.14em] text-nx-sub">
                                    {t(chip)}
                                </span>
                            ))}
                        </Reveal>
                    </div>
                    <div className="lg:col-span-7">
                        <Reveal delay={0.15}>
                            <div className="relative overflow-hidden rounded-2xl border border-white/5 bg-nx-alt" data-testid="global-network-visual">
                                <div className="bg-grid-fine absolute inset-0 opacity-50" aria-hidden="true" />
                                <WorldNetwork className="relative w-full" />
                                <div className="pointer-events-none absolute inset-0 shadow-[inset_0_0_56px_rgba(6,8,9,0.65)]" aria-hidden="true" />
                            </div>
                        </Reveal>
                    </div>
                </div>
            </div>
        </section>
    );
};
